import * as yup from 'yup'

export const schema = yup.object().shape({
    shipping_addresses: yup.array().of(
        yup.object().shape({
            selected_shipping_method: yup.object().shape({
                carrier_code: yup.string().typeError('Musisz wybrać rodzaj wysyłki aby przejść dalej'),
            }),
        })
    ),
})
